<script setup lang="ts">
import { collapseYearRanges, formatYearRange } from '@open-songster/core'
import { computed } from 'vue'

interface Props {
  years: number[]
  tone?: 'excluded' | 'included'
}

const props = withDefaults(defineProps<Props>(), { tone: 'included' })

/** Consecutive years always collapse into a range — never a flat list. */
const ranges = computed(() => collapseYearRanges(props.years))
</script>

<template>
  <ul class="cluster year-range-list">
    <li
      v-for="range of ranges"
      :key="`${range.from}-${range.to}`"
      class="year-chip"
      :class="props.tone === 'excluded' ? 'year-chip--excluded' : 'year-chip--qualifying'"
    >
      {{ formatYearRange(range) }}
    </li>
  </ul>
</template>

<style scoped>
.year-range-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
</style>
